import { Converter } from '../types/converter';

export const chargeConverter: Converter = {
  id: 'charge',
  name: 'Electric Charge Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // SI unit and prefixes
    { name: 'Coulomb', symbol: 'C', factor: 1 },
    { name: 'Megacoulomb', symbol: 'MC', factor: 1e6 },
    { name: 'Kilocoulomb', symbol: 'kC', factor: 1000 },
    { name: 'Millicoulomb', symbol: 'mC', factor: 0.001 },
    { name: 'Microcoulomb', symbol: 'µC', factor: 1e-6 },
    { name: 'Nanocoulomb', symbol: 'nC', factor: 1e-9 },
    { name: 'Picocoulomb', symbol: 'pC', factor: 1e-12 },
    
    // CGS units
    { name: 'Abcoulomb', symbol: 'abC', factor: 10 },
    { name: 'EMU of charge', symbol: 'EMU', factor: 10 },
    { name: 'Statcoulomb', symbol: 'stC', factor: 3.335641e-10 },
    { name: 'ESU of charge', symbol: 'ESU', factor: 3.335641e-10 },
    { name: 'Franklin', symbol: 'Fr', factor: 3.335641e-10 },
    
    // Time-based units
    { name: 'Ampere hour', symbol: 'A*h', factor: 3600 },
    { name: 'Ampere minute', symbol: 'A*min', factor: 60 },
    { name: 'Ampere second', symbol: 'A*s', factor: 1 },
    
    // Chemical units
    { name: 'Faraday (based on carbon 12)', symbol: 'F', factor: 96485.3321233100184 },
    
    // Quantum units
    { name: 'Elementary charge', symbol: 'e', factor: 1.602176634e-19 }
  ]
};
